<template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{ name: 'Users' }">
              <h4 class="ms-2">
                {{ label.pages.users }}
              </h4>
            </b-link>
            /
            <h4 class="me-2">
              {{ $route.meta.label }}
              <small class="fw1">
                {{ label.pages.manageUsers }}
              </small>
            </h4>
          </b-col>
          <b-col cols="2" class="text-start">
            <a
              @click="$router.go(-1)"
              v-b-tooltip.hover.right
              :title="label.pages.previousPage"
              class="mouse-change pe-3"
            >
              <b-icon
                icon="arrow-left-square-fill"
                variant="ps-base"
                scale="1.2"
                class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <DxDataGrid
            :show-row-lines="true"
            :show-column-lines="true"
            :show-borders="true"
            :row-alternation-enabled="true"
            :rtl-enabled="label.direction === 'rtl' ? true : false"
            :data-source="items"
            :columns="fields"
            :remote-operations="true"
            :column-auto-width="true"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            column-resizing-mode="widget"
            :hover-state-enabled="true"
            :noDataText="checkData"
            @toolbar-preparing="onToolbarPreparing($event)"
            key-expr="id"
            class="ps_Table"
            :height="dataGridHeight"
          >
            <DxSearchPanel
              :visible="true"
              :width="240"
              :placeholder="label.pages.search"
            />
            <DxColumnChooser :enabled="true" mode="dragAndDrop" />
            <DxExport :enabled="true" />
            <template #btnRGroup>
              <div></div>
            </template>
            <template #btnGroup>
              <div>
                <b-row class="ms-2">
                  <b-col cols="auto" class="px-1">
                    <b-button
                      variant="ps-secondary"
                      class="py-1 pb-2"
                      size="sm"
                      v-b-tooltip.hover
                      :title="label.buttons.reload"
                      @click="reloadData"
                    >
                      <b-icon
                        icon="arrow-repeat"
                        scale="1.5"
                        color="#fff"
                      ></b-icon>
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </template>
            <template #image="{ data }">
              <div>
                <img
                  :src="data.data.imageAddress"
                  class="ps_table_inside_img"
                />
              </div>
            </template>
            <template #actions="{ data }">
              <b-row class="justify-content-center">
                <b-col cols="auto" class="px-1">
                  <button
                    @click="changeStatus(data)"
                    :id="'changeStatusTlp-' + data.data.id"
                  >
                    <b-icon
                      icon="dash-square-fill"
                      scale="1.1"
                      variant="ps-options-icon"
                    ></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'changeStatusTlp-' + data.data.id"
                  >
                    {{ label.buttons.changeStatus }}
                  </b-tooltip>
                </b-col>

                <b-col cols="auto" class="px-1">
                  <button
                    @click="resetConfirm(data)"
                    :id="'resetPasswordTlp-' + data.data.id"
                  >
                    <b-icon
                      icon="shield-lock-fill"
                      scale="1.2"
                      variant="ps-add-icon"
                    ></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'resetPasswordTlp-' + data.data.id"
                  >
                    {{ label.buttons.resetPassword }}
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <DxSorting mode="multiple" />
            <DxLoadPanel :enabled="true" />
            <DxScrolling mode="virtual" />
            <!-- <DxStateStoring
                :enabled="true"
                type="localStorage"
                storage-key="adminWebsiteUsersList"
            /> -->
          </DxDataGrid>
        </b-card-text>
      </b-card-body>
    </b-card>

    <!-- Change Status Modal -->
    <b-modal
      :dir="label.direction"
      v-model="statusModal"
      header-bg-variant="ps-primary"
      centered
    >
      <template #modal-header>
        <h4 class="text-white fw1">
          {{ label.form.changeUserStatus }}
        </h4>
        <button
          class="ps-closeModalBtn"
          @click="statusModal = false"
          id="closeEditModalTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeEditModalTlp"
        >
          {{ label.buttons.closeModal }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row class="my-3">
          <b-col cols="6">
            <label for="itemStatus" class="ps_label">
              {{ label.form.userStatus }}
              <b>( {{ itemTitle }} )</b>
            </label>
          </b-col>
          <b-col cols="6">
            <label class="ps-switch">
              <input type="checkbox" v-model="itemStatus" />
              <span class="slider round"></span>
            </label>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="statusModal = false"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              v-if="!loadingBtn"
              variant="ps-primary"
              size="sm"
              class="mx-1"
              @click="submitChange"
            >
              {{ label.buttons.saveChanges }}
            </b-button>
            <b-button
              v-else
              disabled
              variant="ps-primary"
              size="sm"
              class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>


    <!-- Reset Password Confirm Modal -->
    <b-modal
        dir="rtl"
        v-model="resetModal"
        hide-header
        centered
    >
      <b-container fluid>
        <b-row class="mt-2">
          <p class="fs10 text-center lh1">
            {{ label.captions.resetPasswordConfirm}}
            <br/>
            <strong>«{{ resetTitle }}»</strong>
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="resetModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-success"
                size="sm"
                class="mx-1"
                @click="resetPassword"
            >
            {{label.buttons.resetPassword}}
            </b-button>
            <b-button
                v-else
                disabled
                variant="ps-danger"
                size="sm"
                class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { dataGridMixin } from "@/components/dataGrid/dataGridMixin";
import label from "@/plugins/StaticLabels.js";

export default {
  name: "UsersList",
  mixins: [dataGridMixin],
  data() {
    return {
      label,
      fields: [
        {
          dataField: "id",
          caption: "کد کاربر",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          cellTemplate: "actions",
          caption: "عملیات",
          allowSorting: false,
          allowFiltering: false,
          cssClass: "text-center align-middle",
          width: "100px",
        },
        {
          dataField: "firstName",
          caption: "نام",
          dataType: "string",
          cssClass: "text-center align-middle fw2",
        },
        {
          dataField: "lastName",
          caption: "نام خانوادگی",
          dataType: "string",
          cssClass: "text-center align-middle fw2",
        },
        {
          cellTemplate: "image",
          caption: "تصویر",
          allowSorting: false,
          allowFiltering: false,
          cssClass: "text-center align-middle",
        },
        {
          dataField: "companyCount",
          caption: "تعداد شرکت‌ها",
          dataType: "string",
          cssClass: "text-center align-middle fw2",
        },
        {
          dataField: "sumPaymentPrice",
          caption: "جمع پرداخت‌ها (ریال)",
          dataType: "number",
          format: "#,##0.###;0;(#,##0.###)",
          cssClass: "text-center align-middle fw2",
        },
        {
          dataField: "userWallet",
          caption: "مانده اعتبار",
          dataType: "number",
          format: "#,##0.###;0;(#,##0.###)",
          cssClass: "text-center align-middle fw2",
        },
        {
          dataField: "mobileNumber",
          caption: "شماره همراه",
          dataType: "string",
          cssClass: "text-center align-middle fw2",
        },
        {
          dataField: "isActive",
          caption: "وضعیت (فعال)",
          dataType: "boolean",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "nationalCode",
          caption: "کد ملی",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "fatherName",
          caption: "نام پدر",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "birthdateLocal",
          caption: "تاریخ تولد",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "genderTitle",
          caption: "جنسیت",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "maritalStatus",
          caption: "وضعیت تأهل",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "nationalId",
          caption: "شماره شناسنامه",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "issuedAt",
          caption: "محصل صدور",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "tel",
          caption: "تلفن ثابت",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "address",
          caption: "آدرس",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
      ],

      statusModal: false,
      itemId: null,
      itemStatus: true,
      itemTitle: "",
      resetId: null,
      resetTitle: "",
      resetModal: false,
    };
  },
  computed: {
    ...mapGetters({
      items: "operationX/websiteUsers",
      loadingBtn: "loadingBtn",
      postCheck: "postCheck",
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.statusModal = false;
        this.reloadData();
      }
    },
  },
  methods: {
    changeStatus(item) {
      this.itemId = item.data.id;
      this.itemStatus = item.data.isActive;
      this.itemTitle = item.data.firstName + " " + item.data.lastName;
      this.statusModal = true;
    },
    submitChange() {
      const payload = {
        id: this.itemId,
        status: this.itemStatus,
      };
      this.$store.dispatch("operationX/changeUserStatus", payload);
    },
    resetConfirm(item) {
      this.resetId = item.data.id;
      this.resetTitle = item.data.firstName + " " + item.data.lastName;
      this.resetModal = true;
    },
    resetPassword() {
      this.$store.dispatch("operationX/resetUserPassword", this.resetId);
      this.resetModal = false;
    },
    reloadData() {
      this.$store.dispatch("operationX/getWebsiteUsers");
    },
  },
  mounted() {
    this.reloadData();
  },
};
</script>
